import { render } from "./Instructions.vue?vue&type=template&id=568e0720&scoped=true"
import script from "./Instructions.vue?vue&type=script&lang=js"
export * from "./Instructions.vue?vue&type=script&lang=js"

import "./Instructions.vue?vue&type=style&index=0&id=568e0720&scoped=true&lang=scss"

import exportComponent from "/pxplus_official_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568e0720"]])

export default __exports__